/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {FormattedHTMLMessage, FormattedMessage, injectIntl} from 'react-intl';
import * as AssetActions from './AssetActions'
import * as SecurityActions from '../security/SecurityActions'
import {Button, Grid} from "@scuf/common";
import Loader from '../common/Loader'
import {formatDateTime} from "../common/LocaleHelper";
import FaultsList from '../faults/list/FaultsList'
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";
import {Routes} from "../utils/Routes";
import ExpandableCard from '../common/ExpandableCard'
import AssetChart from "../common/AssetChart"
import * as Assets from "../api/Assets";
import * as Airtime from "../api/Airtime"
import SearchInput from "../common/SearchInput";
import engineHTF7K from "../styling/images/AS907.png";
import engineTFE731 from "../styling/images/TFE731.png";
import {verifyAirtimeException} from "../utils/Helpers";
import {ASSETS_DATA_SET_TYPE} from "../admin/assets/AssetsConst";

class EngineHistory extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            assetName: '',
            loading: false,
            assets: [],
            apiPoint: userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ? Airtime : Assets,
        }
    }

    componentDidMount() {
        this.props.AssetActions.clearAsset()
        this.fetchAssets()
    }

    fetchAssets() {
        this.setState({loading: true})
        this.state.apiPoint.fetchAssets(ASSETS_DATA_SET_TYPE.SHALLOW_WITH_FAULT_COUNT).then(response => {
            this.setState({
                assets: response,
                loading: false,
            })
            if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)) {
                this.setState({
                    assetName: response[0].name,
                })
            }
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    getAttributesComponents(attrs) {
        //first 4 attributes in two column format
        const mainAttrsRow = this.getAttrsColumnsInRow(attrs.slice(0, 4))
        //rest of attributes in two column format
        const moreAttrsRow = this.getAttrsColumnsInRow(attrs.slice(4, attrs.length))
        return <ExpandableCard
            expandable={attrs.length > 4}
            content={<Grid>{mainAttrsRow}</Grid>}
            expandedContent={<Grid>{moreAttrsRow}</Grid>}
            interactive={false}
            className='attributes-card'
        />
    }

    getAttrsColumnsInRow(attrs) {
        const column1attrs = [<div key='1'></div>]
        attrs.forEach((a) => {
            const attrCmp = this.getAttributesRow(a);
            column1attrs.push(attrCmp)
        })
        return <Grid.Row><Grid.Column width={12}>{column1attrs}</Grid.Column></Grid.Row>
    }

    getAttributesRow(a) {
        let value;
        switch(a.dataType) {
            case 'integer':
                value = a.valueInteger
                break;
            case 'decimal':
                value = a.valueDecimal
                break;
            case 'date':
                value = formatDateTime(a.valueDate)
                break;
            default:
                value = a.valueString
        }
        return  <Grid.Row key={a.code}><Grid.Column width={5}>{a.name}:</Grid.Column><Grid.Column width={7} className="attr-value">{value}</Grid.Column></Grid.Row>
    }

    getEditButton() {
        const {intl, history, asset} = this.props
        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.FLEETS_WRITE)) {
            return <Button content={intl.formatMessage({id: 'link.edit.asset'})} type="secondary"
                           onClick={() => history.push(Routes.ASSETS_ADMIN + "/" + asset.details.id)}/>
        }
        return null
    }

    render() {
        const {intl, userProfile} = this.props

        const external = userHasActivity(userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)

        if (this.state.assetName === '' || this.state.assets.length === 0) {
            const message = this.state.assetName === '' ?
                null
                :
                <FormattedMessage id="engine.history.no.engine"/>
            return (
                <div id="asset-detail" >
                    <Loader loading={this.props.asset.loading}/>
                    {
                        external ?
                            null
                            :
                            <Grid className="asset-header">
                                <Grid.Row>
                                    <SearchInput
                                        className="engine-history-input"
                                        fluid
                                        placeHolder={intl.formatMessage({id: "engine.history.select.engine"})}
                                        onChange={(data) => this.setState({assetName: data})}
                                        setUpTimeout={500}
                                    />
                                </Grid.Row>
                            </Grid>
                    }
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={4} sWidth={12}>
                                {message}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
            )
        }

        const asset = this.state.assets.find(a => a.name === this.state.assetName);

        if (asset == null) {
            return (
                <div id="asset-detail" >
                    <Loader loading={this.props.asset.loading}/>
                    {
                        external ?
                            null
                            :
                            <Grid className="asset-header">
                                <Grid.Row>
                                    <SearchInput
                                        className="engine-history-input"
                                        fluid
                                        placeHolder={intl.formatMessage({id: "engine.history.select.engine"})}
                                        onChange={(data) => this.setState({assetName: data})}
                                        setUpTimeout={500}
                                    />
                                </Grid.Row>
                            </Grid>
                    }
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={4} sWidth={12}>
                                <FormattedMessage id="engine.history.engine.doesnt.exist"/>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
            )
        }

        // Convert variants to same structure as Asset Attributes
        // to be able to render them in same ExpandableCard (variants first, after attributes)
        const variantAsAttribute = asset.variants.map(v => {
            return {
                valueString: v.name,
                dataType: null,
                code: v.code,
                name: intl.formatMessage({id: "assets.asset.detail.variant.type"}, {variantType: v.variantType}),
            }
        })
        const configurationSymptomAsAttribute = asset.configurationSymptoms.map(as => {
            return {valueString: as.state, dataType: null, code: as.name, name: as.name}
        })
        // Concat variants and asset attributes to one array for randering in one expandable card
        configurationSymptomAsAttribute.forEach(asattr => {
            variantAsAttribute.push(asattr)
        })
        // Concat variants and asset attributes to one array for rendering in one expandable card
        asset.attributes.forEach(attr => {
            variantAsAttribute.push(attr)
        })

        const varAndAttrToBeRender = this.getAttributesComponents(variantAsAttribute)

        return (
            <div id="asset-detail">
                <Loader loading={this.state.loading}/>
                {
                    external ?
                        null
                        :
                        <Grid className="asset-header">
                            <Grid.Row>
                                <SearchInput
                                    className="engine-history-input"
                                    fluid
                                    placeHolder={intl.formatMessage({id: "engine.history.select.engine"})}
                                    onChange={(data) => this.setState({assetName: data})}
                                    setUpTimeout={500}
                                />
                            </Grid.Row>
                        </Grid>
                }
                <Grid className="asset-header">
                    <Grid.Row>
                        <Grid.Column width={4} sWidth={12}>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        {
                            userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) && asset.variants.length > 0 ?
                                <Grid.Column width={2} sWidth={12}>
                                    <div>
                                        <img alt="engine" className="engine-picture" src={asset.variants[0].ldiName.includes('HTF7K') ? engineHTF7K : engineTFE731}/>
                                        <FormattedHTMLMessage id={asset.variants[0].ldiName.includes("HTF7K") ? "HTF7K" : "TFE731"}/>
                                    </div>
                                </Grid.Column>
                                :
                                null
                        }
                        <Grid.Column width={4} sWidth={12}>
                            <h2>{asset.name}</h2>
                            <div className="chart">
                                <AssetChart asset={asset} height={220}/>
                            </div>
                        </Grid.Column>
                        <Grid.Column width={6} sWidth={12}>
                            {varAndAttrToBeRender}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <FaultsList assetId={asset.id} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
        asset: state.asset,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        AssetActions: bindActionCreators(AssetActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(EngineHistory)))